import VendorAnalysisChart from "./visualizations/VendorAnalysisChart";
import CustomerAnalysisChart from "./visualizations/TopCustomersChart";


export const CHART_COMPONENTS = {
    'Vendor Analysis': VendorAnalysisChart,
    'Top Customer': CustomerAnalysisChart
  };

  